<template>
  <div class="ah-search-filters">
    <filter-badge
      class="ah-search-filters-item"
      v-for="(category, i) in categories"
      :key="`category-${i}`"
      :filter="category"
    />
    <filter-group-badge
      :label="speciesLabel"
      :filters="species"
    />
    <filter-group-badge
      :label="therapiesLabel"
      :filters="therapies"
    />
  </div>
</template>

<script>
  import { store, mutations } from '../../data/store'
  import FilterBadge from './FilterBadge.vue'
  import FilterGroupBadge from './FilterGroupBadge.vue'

  export default {
    name: 'search-filters',
    methods: {
      activeCount: function(categories) {
        return categories?.reduce((acc, category) => (
          category.active ? acc + 1 : acc
        ), 0) || 0
      },
    },
    data: function() {
      return {
        speciesLabel: window.vueData.components['filters'].speciesLabel || 'Species',
        therapiesLabel: window.vueData.components['filters'].therapiesLabel || 'Therapy area',
      }
    },
    computed: {
      categories: function() {
        return store.categories
      },
      species: function() {
        return store.species
      },
      therapies: function() {
        return store.therapies
      },
    },
    components: {
      FilterBadge,
        FilterGroupBadge,
    }
  }
</script>

<style lang="scss" scoped>
  .ah-search-filters {
    display: flex;
    flex-wrap: wrap;
    margin: -4px;
  }
</style>